const TOKEN = 'TOKEN';

export { TOKEN };
